import { render, staticRenderFns } from "./CompanyInformations.vue?vue&type=template&id=8aae7bfe"
import script from "./CompanyInformations.vue?vue&type=script&lang=js"
export * from "./CompanyInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports